import React from 'react';
import Loading from 'app/loading';
import ContainerHeader from 'components/ContainerHeader/index';
import DataTable from 'components/customized/tables/datatable';
import {urlPrefix, get, post, postForm} from 'engine/dataServices';
import {NotificationManager} from 'react-notifications';
import {FormControl, InputLabel, MenuItem, Input, Select, Button, Paper} from 'material-ui';
import jMoment from 'moment-jalaali';
import {Alert, Card, CardBody, CardFooter, CardHeader} from 'reactstrap';

const ordersHeadTable = [
    {id: 'id', numeric: false, disablePadding: true, label: 'شناسه'},
    {id: 'username', numeric: false, disablePadding: true, label: 'نام کاربری'},
    {id: 'price', numeric: false, disablePadding: true, label: 'مبلغ (تومان)'},
    {id: 'step', numeric: false, disablePadding: true, label: 'وضعیت'},
    {id: 'paymentType', numeric: false, disablePadding: true, label: 'نحوه پرداخت'},
    {id: 'postType', numeric: false, disablePadding: true, label: 'نحوه ارسال'},
    {id: 'createdDate', numeric: true, disablePadding: false, label: 'تاریخ ایجاد'},
    {id: 'modifiedDate', numeric: true, disablePadding: false, label: 'تاریخ آخرین ویرایش'}
];

const ordersDetailsHeadTable = [
    {id: 'id', numeric: false, disablePadding: true, label: 'شناسه'},
    {id: 'name', numeric: false, disablePadding: true, label: 'نام محصول'},
    {id: 'price', numeric: false, disablePadding: true, label: 'مبلغ فاکتور شده (تومان)'},
    {id: 'count', numeric: false, disablePadding: true, label: 'تعداد درخواستی'},
    {id: 'categoryName', numeric: false, disablePadding: true, label: 'عنوان دسته بندی'},
    {id: 'producerName', numeric: false, disablePadding: true, label: 'نام فروشنده'},
    {id: 'createdDate', numeric: true, disablePadding: false, label: 'تاریخ ایجاد'},
    {id: 'modifiedDate', numeric: true, disablePadding: false, label: 'تاریخ آخرین ویرایش'}
];


class Orders extends React.Component {
    constructor(props) {
        super(props);


        this.detailContainerRef = React.createRef();

        this.state = {
            loading: true,
            orders: [],
            orderSteps: [],
            selectedOrderStep: '',
            showDetailContainer: false,
            orderDetails: [],
            orderStep: 0,
            userName: '',
            price: 0,
            paymentType: '',
            postType: '',
            createDate: '',
            modifiedDate: '',
            address: {},
            selectedOrderId: 0
        }
    }

    componentWillMount() {
        this.loadOrderSteps()
    }

    componentDidMount() {
        this.setState({loading: false});
    }

    async loadOrderSteps() {
        const res = await get('Order/GetOrderSteps');
        if (res.status == 200) {
            const data = await res.json();
            this.setState({orderSteps: data});
        }
    }

    async loadOrders() {
        const {selectedOrderStep} = this.state;
        const res = await get(`Order/GetOrders?step=${selectedOrderStep}`);
        if (res.status === 200) {
            const data = await res.json();
            const orderData = data.map((item) => {
                return {
                    id: item.Id,
                    username: item.User.Mobile,
                    price: item.Price.toLocaleString(),
                    step: item.StepTitle,
                    paymentType: item.PaymentTitle,
                    postType: item.PostTitle,
                    createdDate: jMoment(item.CreatedDate).format('HH:mm - jYYYY/jMM/jDD'),
                    modifiedDate: (item.ModifiedDate) ? jMoment(item.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'ّبدون ویرایش'
                }
            });
            this.setState({orders: orderData});
        }
    }

    async loadOrderDetails(orderId) {
        const response = await get(`Order/GetDetailsByOrderId?orderId=${orderId}`);
        if (response.status == 200) {
            let data = await response.json();
            const orderDetailData = data.Details.map((item) => {
                return {
                    id: item.Id,
                    name: item.Product.Name,
                    price: item.Price.toLocaleString(),
                    count: item.Count,
                    categoryName: item.Product.Category.Name,
                    producerName: item.Product.Producer.Name,
                    createdDate: jMoment(item.CreatedDate).format('HH:mm - jYYYY/jMM/jDD'),
                    modifiedDate: (item.ModifiedDate) ? jMoment(item.ModifiedDate).format('HH:mm - jYYYY/jMM/jDD') : 'ّبدون ویرایش'
                }
            });

            this.setState({
                orderDetails: orderDetailData,
                address: data.Address,
                orderStep: data.Step,
                selectedOrderId: data.Id
            });
        }
    }


    handleChange = name => event => {
        this.setState({[name]: event.target.value});
    };

    async handleShowBtn() {
        this.setState({loading: true, showDetailContainer: false});

        this.loadOrders();

        this.setState({loading: false});
    }

    async detailFunc() {
        this.setState({loading: true});

        let selectedId = event.target.getAttribute('data-id');
        if (!selectedId) selectedId = event.target.offsetParent.getAttribute('data-id');
        let rowSelected = event.target.getAttribute('data-extra');
        if (!rowSelected) rowSelected = event.target.offsetParent.getAttribute('data-extra');

        if (selectedId) {
            await this.loadOrderDetails(selectedId);
            const rowSetlectedData = JSON.parse(rowSelected);
            this.setState({
                showDetailContainer: true,
                loading: false,
                userName: rowSetlectedData.username,
                price: rowSetlectedData.price,
                paymentType: rowSetlectedData.paymentType,
                postType: rowSetlectedData.postType,
                createDate: rowSetlectedData.createdDate,
                modifiedDate: rowSetlectedData.modifiedDate
            });
            setTimeout(() => {
                this.scroll(this.detailContainerRef);
            }, 100)
        } else {
            NotificationManager.error('خطا در فراخوانی اطلاعات.', 'خطای سیستمی');
        }
    }

    scroll(ref) {
        ref.current.scrollIntoView({behavior: 'smooth'})
    }

    async updateBtn() {
        try {
            const {selectedOrderId, orderStep} = this.state;
            if (!selectedOrderId)
                return;
            this.setState({loading: true});

            const data = {
                Id: selectedOrderId,
                Step: orderStep
            }

            const response = await post('Order/UpdateStep', data);
            if (response.status == 200) {
                this.loadOrders();
                this.setState({showDetailContainer: false})
                NotificationManager.success('سفارش با موفقیت بروزرسانی شد.', 'عملیات موفق');
            }
        } finally {
            this.setState({loading: false});
        }
    }

    async closeDetailContainer() {
        this.setState({showDetailContainer: false});
    }

    render() {
        const {loading, orders, orderSteps, selectedOrderStep, showDetailContainer, orderDetails, address, orderStep, resultCount} = this.state;


        return (
            <div className="dashboard animated slideInUpTiny animation-duration-6">
                {loading && <Loading/>}

                <ContainerHeader match={this.props.match} title="مدیریت سفارشات"/>

                <div style={{paddingBottom: 15}}>
                    <div className="row">
                        <div className="col-lg-3 col-sm-6 col-12">
                            <FormControl className="w-100 mb-2">
                                <InputLabel htmlFor="age-simple">وضعیت</InputLabel>
                                <Select
                                    value={selectedOrderStep}
                                    onChange={this.handleChange('selectedOrderStep')}
                                    input={<Input id="age-simple"/>}
                                >
                                    {orderSteps.map((item) =>
                                        <MenuItem value={item.Id}>{item.Title}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="row" style={{justifyContent: 'flex-end', marginLeft: 35}}>
                        <Button variant="raised" className="jr-btn bg-primary text-white jr-btn-sm"
                                onClick={this.handleShowBtn.bind(this)}>نمایش</Button>
                    </div>
                </div>

                <Paper>
                    <DataTable columnData={ordersHeadTable} data={orders} detailFunc={this.detailFunc.bind(this)} showOrderCount={true}/>
                </Paper>


                <div id="detailContainer" ref={this.detailContainerRef} style={{paddingTop: 5}}>
                    {showDetailContainer && (
                        <section>
                            <Card className={'shadow border-0'} style={{marginTop: 25}}>
                                <CardHeader className="bg-primary text-white">جزئیات سفارش</CardHeader>
                                <CardBody>
                                    <div style={{marginTop: 20}}>
                                        <div className='lineText'><span>اطلاعات سفارش</span></div>
                                        <div className='row'>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">نام کاربری خریدار</InputLabel>
                                                    <Input id="name-simple" value={this.state.userName}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">مبلغ نهایی فاکتور</InputLabel>
                                                    <Input id="name-simple" value={this.state.price}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">نحوه پرداخت</InputLabel>
                                                    <Input id="name-simple" value={this.state.paymentType}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">نحوه ارسال</InputLabel>
                                                    <Input id="name-simple" value={this.state.postType}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">تاریخ ایجاد سبد خرید</InputLabel>
                                                    <Input id="name-simple" value={this.state.createDate}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="mb-3" fullWidth>
                                                    <InputLabel htmlFor="name-simple">تاریخ اخرین ویرایش
                                                        سفارش</InputLabel>
                                                    <Input id="name-simple" value={this.state.modifiedDate}
                                                           disabled={true}/>
                                                </FormControl>
                                            </div>
                                            <div className="col-lg-3 col-sm-12">
                                                <FormControl className="w-100 mb-2">
                                                    <InputLabel htmlFor="age-simple">وضعیت کنونی سفارش</InputLabel>
                                                    <Select
                                                        value={orderStep}
                                                        onChange={this.handleChange('orderStep')}
                                                        input={<Input id="age-simple"/>}
                                                    >
                                                        {orderSteps.map((item) =>
                                                            <MenuItem value={item.Id}>{item.Title}</MenuItem>
                                                        )}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                        <div style={{marginTop: 50}}>
                                            <div className='lineText'><span>جزئیات سفارش</span></div>
                                            <DataTable columnData={ordersDetailsHeadTable} data={orderDetails}/>
                                        </div>
                                        <div style={{marginTop: 50}}>
                                            <div className='lineText'><span>آدرس و اطلاعات تحویل گیرنده</span></div>
                                            {address ?
                                                <section>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">نام و نام
                                                                    خانوادگی</InputLabel>
                                                                <Input id="name-simple" value={address.PersonName}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                        <div className="col-lg-3 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">شماره
                                                                    تماس</InputLabel>
                                                                <Input id="name-simple" value={address.PhoneNumber}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-3 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">استان</InputLabel>
                                                                <Input id="name-simple" value={address.ProvinceName}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                        <div className="col-lg-3 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">شهر</InputLabel>
                                                                <Input id="name-simple" value={address.CityName}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                        <div className="col-lg-3 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">کد پستی</InputLabel>
                                                                <Input id="name-simple" value={address.PostalCode}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-12 col-sm-12">
                                                            <FormControl className="mb-3" fullWidth>
                                                                <InputLabel htmlFor="name-simple">آدرس کامل</InputLabel>
                                                                <Input id="name-simple" value={address.Address}
                                                                       disabled={true}/>
                                                            </FormControl>
                                                        </div>
                                                    </div>
                                                </section>
                                                :
                                                <Alert className="shadow-lg" color="danger">
                                                    برای این سفارش تا کنون آدرسی در نظر گرفته نشده است.
                                                </Alert>
                                            }
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter>
                                    <div style={{textAlign: 'left'}}>
                                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.updateBtn.bind(this)}>
                                            <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                            <span>ثبت</span>
                                        </Button>
                                        <Button variant="raised" className="jr-btn bg-red jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.closeDetailContainer.bind(this)}>
                                            <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                            <span>انصراف</span>
                                        </Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </section>
                    )}
                </div>


            </div>
        );
    }

}

export default Orders;




// WEBPACK FOOTER //
// ./app/routes/toliton/orders/orders.js